import clsx from 'clsx'
import { Field } from 'formik'
import React from 'react'

// This component is meant to be used with Formik.
// As the first iteration this will be the dafult behavior.
// If there will be checkbox without formik, please update the component or create new one.

const WifCheckbox: React.FC<{
  id: string
  label: string
  name: string
  value: string
  disabled?: boolean
  checked?: boolean
  disableInteraction?: boolean
}> = ({ id, label, name, value, checked, disabled = false, disableInteraction = false }) => {
  return (
    <label
      htmlFor={id}
      data-test={`${id}-checkbox-label`}
      className={clsx(
        disableInteraction
          ? 'cursor-none disabled'
          : 'p-[10px] border rounded-lg cursor-pointer text-sm flex items-center'
      )}
    >
      <label
        htmlFor={disableInteraction ? '' : id}
        className={clsx(
          'rounded-[10px] p-2 mr-2 cursor-pointer w-[30px] h-[30px] flex justify-center items-center transition-all',
          !!checked ? 'bg-wif-orange rotate-[360deg]' : 'bg-[#F7F7F7] rotate-0'
        )}
      >
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='15'
          height='11'
          viewBox='0 0 15 11'
          fill='none'
        >
          <path
            d='M1.67743 5.19389L6.12904 9.38744L13.2903 1.64551'
            stroke={!!checked ? '#FFF' : '#DDD'}
            strokeWidth='2'
          />
        </svg>
      </label>
      <div className='opacity-0 invisible h-0 w-0'>
        <Field
          id={id}
          data-test={`${id}-checkbox`}
          type='checkbox'
          name={name}
          value={value}
          checked={checked}
          disabled={disabled}
        />
      </div>
      {label}
    </label>
  )
}

export default WifCheckbox
